import { Section, SectionTitle, PageHero, CTA, FeatureCard } from "@/components/site/SiteBits";
import { FileText, ClipboardCheck, Award, Flag, ShieldCheck, Coins } from "lucide-react";

const F = [
  { icon: FileText, title: "Customs Documentation", desc: "Configurable workflows for import/export declarations." },
  { icon: ClipboardCheck, title: "Commercial Invoices & Packing Lists", desc: "Structured trade documents attached per consignment." },
  { icon: Award, title: "Certificates of Origin", desc: "SADC and preferential trade certificate handling." },
  { icon: Flag, title: "Border Status Tracking", desc: "Live visibility of consignments at Beitbridge, Lebombo and more." },
  { icon: ShieldCheck, title: "Shipment Compliance", desc: "Rule-based compliance checks before dispatch." },
  { icon: Coins, title: "Duties & Fees", desc: "Configurable duty and levy estimation — no hard-coded rates." },
];

const CORRIDORS = [
  "Johannesburg → Gaborone (Botswana)",
  "Johannesburg → Maputo (Mozambique)",
  "Johannesburg → Harare (Zimbabwe)",
  "Johannesburg → Lusaka (Zambia)",
  "Cape Town → Windhoek (Namibia)",
];

export default function CrossBorder() {
  return (
    <div>
      <PageHero eyebrow="Cross-Border Logistics" title="Freight that moves across Southern Africa"
        subtitle="Configurable cross-border workflows for customs, documentation and compliance — architected for SADC expansion with verified integrations rather than assumed regulations."
        image="/services/cross-border.jpg" />
      <Section>
        <SectionTitle eyebrow="Compliance-First" title="Built for regional trade" />
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {F.map((f) => <FeatureCard key={f.title} {...f} />)}
        </div>
      </Section>
      <Section className="!pt-0">
        <div className="rounded-2xl border border-border bg-card p-8">
          <h3 className="font-heading font-bold text-xl mb-4">Active regional corridors</h3>
          <div className="grid sm:grid-cols-2 gap-3">
            {CORRIDORS.map((c) => (
              <div key={c} className="flex items-center gap-3 rounded-lg bg-accent p-3.5 text-sm font-medium">
                <span className="w-2 h-2 rounded-full bg-primary" /> {c}
              </div>
            ))}
          </div>
        </div>
      </Section>
      <CTA />
    </div>
  );
}
